import { gql } from '../../__generated__/gql'

export const COMMUNITY_PROFILE_CONSOLIDATED_NOTIFICATIONS_QUERY = gql(`
  query communityProfileConsolidatedNotifications($page: Int, $perPage: Int) {
    communityProfileConsolidatedNotifications(page: $page, perPage: $perPage) {
      notifications {
        id
        actionPerformers {
          id
          firstName
          lastName
          picture
        }
        actionPerformersCount
        read
        actionType
        createdAt
        resource {
          user {
            id
          }
          levelInfo {
            level
          }
          post {
            id
            category {
              id
              title
            }
          }
          comment {
            id
          }
          labCourse {
            id
          }
        }
      }
      total
      totalUnread
    }
  }
`)
